import { separatorString } from './constants';
export const omitEdgeSeparators = (items) => items.filter((item, ind, arr) => {
    const isFirst = ind === 0;
    const isLast = ind === arr.length - 1;
    const itemIsSeparator = new RegExp(separatorString).test(item);
    return !((isFirst || isLast) && itemIsSeparator);
});
const getItemsPos = (items) => {
    var _a;
    const normalizedItems = omitEdgeSeparators(items);
    const centerIndex = Math.floor(normalizedItems.length / 2);
    const center = normalizedItems[centerIndex];
    return {
        first: normalizedItems === null || normalizedItems === void 0 ? void 0 : normalizedItems[0],
        center,
        last: (_a = normalizedItems.slice(-1)) === null || _a === void 0 ? void 0 : _a[0],
    };
};
export default getItemsPos;
